import { BaseService } from "./BaseService";

export class DataCollectionService extends BaseService {

    constructor(url) {
        super(url);
    }

    async getFormById(queryParams) {
        return this.get(queryParams)
    }

    async createform(queryParams) {
        return this.create(queryParams)
    }

}